import { TooltipContainer, Arrow, IconContainer, TooltipButton } from './styles.js';
import { TooltipContentAlignment, TooltipSize, SPACING_FROM_ANCHOR, SPACING_FROM_NEAREST_CORNER } from './constants.js';
import { TooltipType, TooltipInteractionType, TooltipContentWrapperDisplayMode } from './types.js';
import { InlineChildren, InsetSize, Icon, IconSize, IconColor, StackChildren, StackChildrenSize, Text, TextStyle, TextColor, TextDisplayMode, IconType, ThemingContext } from '@doordash/design-language';
import { AnchoredLayerPosition, AnchoredLayerBoundariesElement, AnchoredLayerFlippedPositions, AnchoredLayer } from '@doordash/component-layer-manager';
import FocusLock from '@doordash/component-focus-lock';
import React from 'react';
import { withUniqueId } from '@doordash/utilities';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var PREFIX_ID = 'Tooltip';

var getOffsetForPosition = function getOffsetForPosition(position) {
  switch (position) {
    case AnchoredLayerPosition.TopLeft:
    case AnchoredLayerPosition.BottomLeft:
      return [-SPACING_FROM_NEAREST_CORNER, SPACING_FROM_ANCHOR];

    case AnchoredLayerPosition.TopRight:
    case AnchoredLayerPosition.BottomRight:
      return [SPACING_FROM_NEAREST_CORNER, SPACING_FROM_ANCHOR];

    case AnchoredLayerPosition.RightTop:
    case AnchoredLayerPosition.LeftTop:
      return [-SPACING_FROM_NEAREST_CORNER, SPACING_FROM_ANCHOR * 1.5];

    case AnchoredLayerPosition.RightBottom:
    case AnchoredLayerPosition.LeftBottom:
      return [SPACING_FROM_NEAREST_CORNER, SPACING_FROM_ANCHOR * 1.5];

    case AnchoredLayerPosition.TopCenter:
    case AnchoredLayerPosition.BottomCenter:
      return [0, SPACING_FROM_ANCHOR];

    case AnchoredLayerPosition.RightCenter:
    case AnchoredLayerPosition.LeftCenter:
    default:
      return [0, SPACING_FROM_ANCHOR * 1.5];
  }
};

var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this$context, _this$context$Colors, _this$context2, _this$context2$Colors, _this$context3, _this$context3$Colors, _this$context4, _this$context4$Colors, _this$context5, _this$context5$Colors, _this$context6, _this$context6$Colors, _this$context7, _this$context7$Colors, _this$context8, _this$context8$Colors, _this$context9, _this$context9$Colors, _this$context10, _this$context10$Color, _this$context11, _this$context11$Color, _this$context12, _this$context12$Color;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      arrowElement: undefined,
      isVisible: _this.props.defaultIsVisible || false,
      isFlipped: false
    });

    _defineProperty(_assertThisInitialized(_this), "getActualPosition", function (position) {
      return _this.state.isFlipped ? AnchoredLayerFlippedPositions[position] : position;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVisibility", function () {
      var prevIsVisible = _this.state.isVisible;

      _this.setState(function (state) {
        return {
          isVisible: !state.isVisible
        };
      }, function () {
        return _this.propagateVisibilityChange(prevIsVisible);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setVisibility", function (visibility) {
      var prevIsVisible = _this.state.isVisible;

      _this.setState({
        isVisible: visibility
      }, function () {
        return _this.propagateVisibilityChange(prevIsVisible);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "propagateVisibilityChange", function (prevIsVisible) {
      if (_this.props.onVisibilityChange && _this.state.isVisible !== prevIsVisible) {
        _this.props.onVisibilityChange(_this.state.isVisible);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "visibilityTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "setVisibilityWithTimer", function (visibility) {
      if (_this.props.interactionType !== TooltipInteractionType.ToggleHover) {
        return;
      }

      if (visibility) {
        clearTimeout(_this.visibilityTimer);

        if (!_this.state.isVisible) {
          // don't set it if it's already set.
          _this.setVisibility(true);
        }
      } else {
        _this.visibilityTimer = setTimeout(function () {
          return _this.setVisibility(false);
        }, 300);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getEventHandlersForInteractionType", function (interactionType) {
      switch (interactionType) {
        case TooltipInteractionType.Hover:
          return {
            onMouseEnter: function onMouseEnter() {
              return _this.setVisibility(true);
            },
            onFocus: function onFocus() {
              return _this.setVisibility(true);
            }
          };

        case TooltipInteractionType.Focus:
          return {
            onFocus: function onFocus() {
              return _this.setVisibility(true);
            }
          };

        case TooltipInteractionType.Click:
          return {
            onClick: function onClick() {
              return _this.setVisibility(true);
            },
            onFocus: function onFocus() {
              return _this.setVisibility(true);
            }
          };

        case TooltipInteractionType.ToggleHover:
          return {
            onMouseEnter: function onMouseEnter() {
              _this.setVisibilityWithTimer(true);
            },
            onMouseLeave: function onMouseLeave() {
              _this.setVisibilityWithTimer(false);
            },
            onFocus: function onFocus() {
              return _this.setVisibilityWithTimer(true);
            },
            onBlur: function onBlur() {
              return _this.setVisibilityWithTimer(false);
            }
          };

        case TooltipInteractionType.ToggleFocus:
          return {
            onFocus: function onFocus() {
              return _this.setVisibility(true);
            },
            onBlur: function onBlur() {
              return _this.setVisibility(false);
            }
          };

        case TooltipInteractionType.ToggleClick:
          return {
            onClick: function onClick() {
              return _this.toggleVisibility();
            }
          };

        case TooltipInteractionType.Controlled:
        default:
          return {};
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setArrowElement", function (ref) {
      _this.setState({
        arrowElement: ref
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      } else {
        _this.setVisibility(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFlippedChange", function (_ref) {
      var flipped = _ref.flipped;
      return _this.setState({
        isFlipped: flipped
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isCloseVisible", function (interactionType, shouldCloseBeVisible) {
      if (typeof shouldCloseBeVisible === 'boolean') {
        return shouldCloseBeVisible;
      }

      switch (interactionType) {
        case TooltipInteractionType.Hover:
        case TooltipInteractionType.Focus:
        case TooltipInteractionType.Click:
        case TooltipInteractionType.ToggleClick:
          return true;

        case TooltipInteractionType.ToggleHover:
        case TooltipInteractionType.ToggleFocus:
        default:
          return false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "tooltipTypes", {
      Informational: {
        Normal: {
          Background: (_this$context = _this.context) === null || _this$context === void 0 ? void 0 : (_this$context$Colors = _this$context.Colors) === null || _this$context$Colors === void 0 ? void 0 : _this$context$Colors.TooltipInformationalBackground,
          Foreground: (_this$context2 = _this.context) === null || _this$context2 === void 0 ? void 0 : (_this$context2$Colors = _this$context2.Colors) === null || _this$context2$Colors === void 0 ? void 0 : _this$context2$Colors.TooltipInformationalForeground
        },
        Hovered: {
          Background: (_this$context3 = _this.context) === null || _this$context3 === void 0 ? void 0 : (_this$context3$Colors = _this$context3.Colors) === null || _this$context3$Colors === void 0 ? void 0 : _this$context3$Colors.TooltipInformationalBackgroundHovered,
          Foreground: (_this$context4 = _this.context) === null || _this$context4 === void 0 ? void 0 : (_this$context4$Colors = _this$context4.Colors) === null || _this$context4$Colors === void 0 ? void 0 : _this$context4$Colors.TooltipInformationalForegroundHovered
        },
        Pressed: {
          Background: (_this$context5 = _this.context) === null || _this$context5 === void 0 ? void 0 : (_this$context5$Colors = _this$context5.Colors) === null || _this$context5$Colors === void 0 ? void 0 : _this$context5$Colors.TooltipInformationalBackgroundPressed,
          Foreground: (_this$context6 = _this.context) === null || _this$context6 === void 0 ? void 0 : (_this$context6$Colors = _this$context6.Colors) === null || _this$context6$Colors === void 0 ? void 0 : _this$context6$Colors.TooltipInformationalForegroundPressed
        }
      },
      Highlight: {
        Normal: {
          Background: (_this$context7 = _this.context) === null || _this$context7 === void 0 ? void 0 : (_this$context7$Colors = _this$context7.Colors) === null || _this$context7$Colors === void 0 ? void 0 : _this$context7$Colors.TooltipHighlightBackground,
          Foreground: (_this$context8 = _this.context) === null || _this$context8 === void 0 ? void 0 : (_this$context8$Colors = _this$context8.Colors) === null || _this$context8$Colors === void 0 ? void 0 : _this$context8$Colors.TooltipHighlightForeground
        },
        Hovered: {
          Background: (_this$context9 = _this.context) === null || _this$context9 === void 0 ? void 0 : (_this$context9$Colors = _this$context9.Colors) === null || _this$context9$Colors === void 0 ? void 0 : _this$context9$Colors.TooltipHighlightBackgroundHovered,
          Foreground: (_this$context10 = _this.context) === null || _this$context10 === void 0 ? void 0 : (_this$context10$Color = _this$context10.Colors) === null || _this$context10$Color === void 0 ? void 0 : _this$context10$Color.TooltipHighlightForegroundHovered
        },
        Pressed: {
          Background: (_this$context11 = _this.context) === null || _this$context11 === void 0 ? void 0 : (_this$context11$Color = _this$context11.Colors) === null || _this$context11$Color === void 0 ? void 0 : _this$context11$Color.TooltipHighlightBackgroundPressed,
          Foreground: (_this$context12 = _this.context) === null || _this$context12 === void 0 ? void 0 : (_this$context12$Color = _this$context12.Colors) === null || _this$context12$Color === void 0 ? void 0 : _this$context12$Color.TooltipHighlightForegroundPressed
        }
      }
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$context13,
          _this$context13$Borde,
          _this$context14,
          _this$context14$Shape,
          _this$context15,
          _this$context15$Borde;

      var _this$props = this.props,
          _this$props$boundarie = _this$props.boundariesElement,
          boundariesElement = _this$props$boundarie === void 0 ? null : _this$props$boundarie,
          _this$props$alignCont = _this$props.alignContent,
          alignContent = _this$props$alignCont === void 0 ? TooltipContentAlignment.Stretch : _this$props$alignCont,
          content = _this$props.content,
          children = _this$props.children,
          _this$props$position = _this$props.position,
          position = _this$props$position === void 0 ? AnchoredLayerPosition.BottomCenter : _this$props$position,
          iconStart = _this$props.iconStart,
          isVisibleProp = _this$props.isVisible,
          _this$props$contentDi = _this$props.contentDisplayMode,
          contentDisplayMode = _this$props$contentDi === void 0 ? TooltipContentWrapperDisplayMode.InlineFlex : _this$props$contentDi,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? TooltipType.Informational : _this$props$type,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? TooltipSize.Large : _this$props$size,
          _this$props$interacti = _this$props.interactionType,
          interactionType = _this$props$interacti === void 0 ? TooltipInteractionType.ToggleHover : _this$props$interacti,
          title = _this$props.title,
          contentMaxLines = _this$props.contentMaxLines,
          titleMaxLines = _this$props.titleMaxLines,
          shouldCloseBeVisible = _this$props.shouldCloseBeVisible,
          uniqueId = _this$props.uniqueId;
      var actualPosition = this.getActualPosition(position);
      var offset = getOffsetForPosition(actualPosition);
      var isCloseVisible = this.isCloseVisible(interactionType, shouldCloseBeVisible);
      var isVisible = typeof isVisibleProp === 'boolean' ? isVisibleProp : this.state.isVisible;
      return /*#__PURE__*/React.createElement(AnchoredLayer, {
        offset: offset,
        position: position,
        arrowElement: this.state.arrowElement,
        shouldEscapeWithAnchor: false,
        onFlippedChange: this.handleFlippedChange,
        boundariesElement: boundariesElement,
        content: isVisible && /*#__PURE__*/React.createElement(FocusLock, {
          disableFocusLock: !isCloseVisible
        }, /*#__PURE__*/React.createElement(TooltipContainer, {
          onMouseEnter: function onMouseEnter() {
            _this2.setVisibilityWithTimer(true);
          },
          onMouseLeave: function onMouseLeave() {
            _this2.setVisibilityWithTimer(false);
          },
          borderRadius: (_this$context13 = this.context) === null || _this$context13 === void 0 ? void 0 : (_this$context13$Borde = _this$context13.BorderRadius) === null || _this$context13$Borde === void 0 ? void 0 : _this$context13$Borde.TooltipContainer,
          containerShape: (_this$context14 = this.context) === null || _this$context14 === void 0 ? void 0 : (_this$context14$Shape = _this$context14.Shape) === null || _this$context14$Shape === void 0 ? void 0 : _this$context14$Shape.Tooltip,
          id: uniqueId,
          role: "tooltip",
          position: actualPosition,
          tooltipType: this.tooltipTypes[type],
          size: size
        }, /*#__PURE__*/React.createElement(Arrow, {
          ref: this.setArrowElement,
          position: actualPosition,
          tooltipType: this.tooltipTypes[type]
        }), /*#__PURE__*/React.createElement(InlineChildren, {
          size: size,
          alignItems: alignContent
        }, iconStart && iconStart.type && /*#__PURE__*/React.createElement(IconContainer, {
          size: InsetSize.XxxSmall
        }, /*#__PURE__*/React.createElement(Icon, _extends({
          shouldAdjustSmallSizesWhitespace: true,
          size: size === TooltipSize.Small ? IconSize.Small : IconSize.Medium,
          color: IconColor["Tooltip".concat(type, "Foreground")]
        }, iconStart))), /*#__PURE__*/React.createElement(StackChildren, {
          size: StackChildrenSize.XxxxSmall
        }, title && /*#__PURE__*/React.createElement(Text, {
          tag: typeof title === 'string' ? 'h2' : undefined,
          styles: TextStyle.TooltipLabel,
          color: TextColor["Tooltip".concat(type, "Foreground")],
          display: TextDisplayMode.Block,
          maxLines: titleMaxLines
        }, title), content && /*#__PURE__*/React.createElement(Text, {
          tag: typeof content === 'string' ? 'p' : undefined,
          styles: TextStyle.TooltipBody,
          color: TextColor["Tooltip".concat(type, "Foreground")],
          maxLines: contentMaxLines
        }, content)), isCloseVisible && /*#__PURE__*/React.createElement(TooltipButton, {
          "aria-label": "Close Tooltip",
          borderRadius: (_this$context15 = this.context) === null || _this$context15 === void 0 ? void 0 : (_this$context15$Borde = _this$context15.BorderRadius) === null || _this$context15$Borde === void 0 ? void 0 : _this$context15$Borde.TooltipButtonClose,
          onClick: this.handleClose,
          tooltipType: this.tooltipTypes[type],
          size: size
        }, /*#__PURE__*/React.createElement(Icon, {
          shouldAdjustSmallSizesWhitespace: true,
          type: IconType.Close,
          color: IconColor["Tooltip".concat(type, "Foreground")],
          size: IconSize.Small
        })))))
      }, /*#__PURE__*/React.createElement("div", _extends({
        style: {
          display: contentDisplayMode
        }
      }, this.getEventHandlersForInteractionType(interactionType)), children({
        describedBy: isVisible ? uniqueId : undefined
      })));
    }
  }]);

  return Tooltip;
}(React.Component);

_defineProperty(Tooltip, "contextType", ThemingContext);

_defineProperty(Tooltip, "Positions", AnchoredLayerPosition);

_defineProperty(Tooltip, "BoundariesElements", AnchoredLayerBoundariesElement);

_defineProperty(Tooltip, "ContentAlignments", TooltipContentAlignment);

_defineProperty(Tooltip, "InteractionTypes", TooltipInteractionType);

_defineProperty(Tooltip, "ContentDisplayModes", TooltipContentWrapperDisplayMode);

_defineProperty(Tooltip, "Types", TooltipType);

_defineProperty(Tooltip, "Sizes", TooltipSize);

_defineProperty(Tooltip, "defaultProps", {
  alignContent: TooltipContentAlignment.Stretch,
  type: TooltipType.Informational,
  size: TooltipSize.Large,
  defaultIsVisible: false,
  position: AnchoredLayerPosition.BottomCenter,
  interactionType: TooltipInteractionType.ToggleHover,
  boundariesElement: null,
  contentDisplayMode: TooltipContentWrapperDisplayMode.InlineFlex
});

var WrappedTooltip = withUniqueId(Tooltip, {
  prefix: PREFIX_ID
});
WrappedTooltip.Positions = AnchoredLayerPosition;
WrappedTooltip.ContentAlignments = TooltipContentAlignment;
WrappedTooltip.Types = TooltipType;
WrappedTooltip.Sizes = TooltipSize;
WrappedTooltip.BoundariesElements = AnchoredLayerBoundariesElement;
WrappedTooltip.InteractionTypes = TooltipInteractionType;
WrappedTooltip.ContentDisplayModes = TooltipContentWrapperDisplayMode;

export { Tooltip, WrappedTooltip as default };
